import { useLocation } from "react-router-dom";

export default function useSearchQuery() {
  return new URLSearchParams(useLocation().search);
}
